import {
  integerFormatterOrFallback,
  usdFormatterOrFallback,
} from 'utils/formatting'

/**
 * Format an aggregated measure value for display, inferred from its label so
 * every renderer (metric card, summary table, ranked list, chart tooltip)
 * shows the same units without each re-deriving the rule:
 *   - "…Rate"    → percentage (the value is a 0–1 average, e.g. win rate)
 *   - "…Revenue" → USD
 *   - everything else → integer (counts, volumes, days)
 *
 * `compact` switches large numbers to short notation (130,560 → "131K",
 * 1,800,000 → "1.8M") for tight stat cards. Rates are already compact.
 */
export function formatMeasure(
  label: string,
  value: number,
  compact = false
): string {
  const l = label.toLowerCase()
  if (l.includes('rate')) return `${(value * 100).toFixed(1)}%`
  if (compact && Number.isFinite(value)) {
    return new Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumFractionDigits: 1,
      ...(l.includes('revenue') ? { style: 'currency', currency: 'USD' } : {}),
    }).format(value)
  }
  if (l.includes('revenue')) return usdFormatterOrFallback(value)
  return integerFormatterOrFallback(value)
}
